import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as PriceListReducer from './priceListv2.reducer';
import * as _ from 'lodash';
import { selectRouteParam } from '../router/router.selector';

export const stateFeature = createFeatureSelector<PriceListReducer.State>(PriceListReducer.priceListFeatureKey);

export const selectPriceListState = createFeatureSelector<PriceListReducer.State>(PriceListReducer.priceListFeatureKey);
const listSelectors = PriceListReducer.listAdapter.getSelectors((state: PriceListReducer.State) => state.list);

/**************************
 * List Adapter Selectors
 **************************/

export const getPriceLists = createSelector(selectPriceListState, listSelectors.selectAll);
export const getPriceListsTotalInStore = createSelector(selectPriceListState, listSelectors.selectTotal);
export const getPriceListsTotal = createSelector(selectPriceListState, (state: PriceListReducer.State) => parseInt(_.get(state, ['list', 'meta', 'total'], '0'), 10));
export const getPriceListsMeta = createSelector(selectPriceListState, (state: PriceListReducer.State) => _.get(state, ['list', 'meta'], undefined));
export const isPriceListsLoading = createSelector(selectPriceListState, (state: PriceListReducer.State) => _.get(state, ['list', 'loading'], false));
export const isPriceListsLoadingNext = createSelector(selectPriceListState, (state: PriceListReducer.State) => _.get(state, ['list', 'loadingNext'], false));
export const isPriceListsLoaded = createSelector(selectPriceListState, (state: PriceListReducer.State) => _.get(state, ['list', 'loaded'], false));

/**************************
 * Single Selectors
 **************************/
export const getDefaultPriceList = createSelector(selectPriceListState, (state: PriceListReducer.State) => _.get(state, ['defaultPriceList'], undefined));

/**************************
 * Single Selectors
 **************************/

export const getPriceList = (props: { price_list_uuid: string }) => createSelector(stateFeature, (state: PriceListReducer.State) => state.single.entities[props.price_list_uuid]);

export const isPriceListLoading = (props: { price_list_uuid: string }) => createSelector(stateFeature, (state: PriceListReducer.State) =>
  _.get(state, ['single', 'loading', props.price_list_uuid], false)
);
export const isPriceListLoaded = (props: { price_list_uuid: string }) => createSelector(stateFeature, (state: PriceListReducer.State) =>
  _.has(state, ['single', 'entities', props.price_list_uuid])
);
export const isPriceListPatching = (props: { price_list_uuid: string }) => createSelector(stateFeature, (state: PriceListReducer.State) =>
  _.get(state, ['single', 'patching', props.price_list_uuid], false)
);
export const isPriceListDeleting = (props: { price_list_uuid: string }) => createSelector(stateFeature, (state: PriceListReducer.State) =>
  _.get(state, ['single', 'deleting', props.price_list_uuid], false)
);

/**************************
 * Single Selected Selectors
 **************************/
export const getSelectedPriceList = createSelector(
  selectPriceListState,
  selectRouteParam('price_list_uuid'),
  (state: PriceListReducer.State, price_list_uuid) => state.single.entities[price_list_uuid]
);
export const isSelectedPriceListLoading = createSelector(selectPriceListState, selectRouteParam('price_list_uuid'), (state: PriceListReducer.State, price_list_uuid) =>
  _.get(state, ['single', 'loading', price_list_uuid], false)
);
export const isSelectedPriceListLoaded = createSelector(selectPriceListState, selectRouteParam('price_list_uuid'), (state: PriceListReducer.State, price_list_uuid) =>
  _.has(state, ['single', 'entities', price_list_uuid])
);
export const isSelectedPriceListPatching = createSelector(selectPriceListState, selectRouteParam('price_list_uuid'), (state: PriceListReducer.State, price_list_uuid) =>
  _.get(state, ['single', 'patching', price_list_uuid], false)
);
export const isSelectedPriceListDeleting = createSelector(selectPriceListState, selectRouteParam('price_list_uuid'), (state: PriceListReducer.State, price_list_uuid) =>
  _.get(state, ['single', 'deleting', price_list_uuid], false)
);

/**************************
 * Single Selected Contracts Selectors
 **************************/
export const getSelectedPriceListContracts = createSelector(selectPriceListState, selectRouteParam('price_list_uuid'), (state: PriceListReducer.State, price_list_uuid) =>
  state.price_list_contracts && state.price_list_contracts[price_list_uuid] ? state.price_list_contracts[price_list_uuid].data : []
);

export const getSelectedPriceListContractsMeta = createSelector(
  selectPriceListState,
  selectRouteParam('price_list_uuid'),
  (state: PriceListReducer.State, price_list_uuid) => _.get(state, ['price_list_contracts', price_list_uuid, 'meta'])
);
export const getSelectedPriceListContractsMetaTotal = createSelector(
  selectPriceListState,
  selectRouteParam('price_list_uuid'),
  (state: PriceListReducer.State, price_list_uuid) => _.get(state, ['price_list_contracts', price_list_uuid, 'meta', 'total'], 0) * 1
);
export const getSelectedPriceListContractsListConfig = createSelector(
  selectPriceListState,
  selectRouteParam('price_list_uuid'),
  (state: PriceListReducer.State, price_list_uuid) => _.get(state, ['price_list_contracts', price_list_uuid, 'list'], false)
);
export const isSelectedPriceListContractsLoaded = createSelector(
  selectPriceListState,
  selectRouteParam('price_list_uuid'),
  (state: PriceListReducer.State, price_list_uuid) => _.get(state, ['price_list_contracts', price_list_uuid, 'loaded'], false)
);
export const isSelectedPriceListContractsLoading = createSelector(
  selectPriceListState,
  selectRouteParam('price_list_uuid'),
  (state: PriceListReducer.State, price_list_uuid) => _.get(state, ['price_list_contracts', price_list_uuid, 'loading'], false)
);
export const isSelectedPriceListContractsLoadingNext = createSelector(
  selectPriceListState,
  selectRouteParam('price_list_uuid'),
  (state: PriceListReducer.State, price_list_uuid) => _.get(state, ['price_list_contracts', price_list_uuid, 'loadingNext'], false)
);
